module.exports = __webpack_public_path__ + "../dist/static/media/Hub_Tablet_Screen.3d99076c.jpg";